/* 
Archivo: assets/marina-transformate.js
Descripción: JavaScript interactivo para el evento TRANSFÓRMATE de Marina Borensztein
*/

document.addEventListener('DOMContentLoaded', function() {
    
    // ===============================
    // INICIALIZACIÓN
    // ===============================
    initScrollEffects();
    initSmoothScrolling();
    initFAQ();
    initHeaderScroll();
    initScrollProgress();
    initAnimationsOnScroll();
    initAnalytics();
// Activar solo si el producto no está disponible
/*if (!window.location.href.includes('.shopifypreview.com') || 
    document.querySelector('.pricing-error')) {
    initTestMode();
} else {
    initDirectBuy(); // Función normal
} */   
    //console.log('🚀 Marina TRANSFÓRMATE Landing Page initialized!');
    
    // ===============================
    // SMOOTH SCROLLING
    // ===============================
    function initSmoothScrolling() {
        const links = document.querySelectorAll('a[href^="#"]');
        
        links.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    const headerHeight = document.querySelector('.marina-header').offsetHeight;
                    const targetPosition = targetElement.offsetTop - headerHeight - 20;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                    
                    // Analytics tracking
                    trackEvent('Navigation', 'Click', targetId);
                }
            });
        });
    }
    
    // ===============================
    // HEADER SCROLL EFFECTS
    // ===============================
    function initHeaderScroll() {
        const header = document.querySelector('.marina-header');
        if (!header) return;
        
        let lastScrollY = window.scrollY;
        let ticking = false;
        
        function handleScroll() {
            const currentScrollY = window.scrollY;
            
            // Cambiar estilo del header basado en scroll
            if (currentScrollY > 100) {
                header.style.background = 'rgba(255, 255, 255, 0.98)';
                header.style.boxShadow = '0 4px 20px rgba(119, 119, 119, 0.15)';
                header.style.borderBottom = '1px solid rgba(119, 119, 119, 0.1)';
            } else {
                header.style.background = 'rgba(255, 255, 255, 0.95)';
                header.style.boxShadow = 'none';
                header.style.borderBottom = '1px solid rgba(119, 119, 119, 0.2)';
            }
            
            // Ocultar/mostrar header en scroll
            if (currentScrollY > lastScrollY && currentScrollY > 200) {
                header.style.transform = 'translateY(-100%)';
            } else {
                header.style.transform = 'translateY(0)';
            }
            
            lastScrollY = currentScrollY;
            ticking = false;
        }
        
        window.addEventListener('scroll', function() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        });
    }
    
    // ===============================
    // SCROLL PROGRESS INDICATOR
    // ===============================
    function initScrollProgress() {
        // Crear barra de progreso
        const progressContainer = document.createElement('div');
        progressContainer.className = 'scroll-indicator';
        progressContainer.innerHTML = '<div class="scroll-progress"></div>';
        document.body.appendChild(progressContainer);
        
        const progressBar = document.querySelector('.scroll-progress');
        
        function updateProgress() {
            const scrollTop = window.pageYOffset;
            const docHeight = document.body.scrollHeight - window.innerHeight;
            const scrollPercent = (scrollTop / docHeight) * 100;
            
            progressBar.style.width = scrollPercent + '%';
        }
        
        window.addEventListener('scroll', throttle(updateProgress, 10));
    }
    
    // ===============================
    // FAQ ACCORDION
    // ===============================
    function initFAQ() {
        const faqItems = document.querySelectorAll('.faq-item');
        
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            
            question.addEventListener('click', function() {
                const isActive = item.classList.contains('active');
                
                // Cerrar todos los otros items
                faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
                
                // Toggle current item
                item.classList.toggle('active', !isActive);
                
                // Analytics
                trackEvent('FAQ', isActive ? 'Close' : 'Open', question.querySelector('h4').textContent);
            });
            
            // Accesibilidad con teclado
            question.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    question.click();
                }
            });
            
            // Atributos de accesibilidad
            question.setAttribute('role', 'button');
            question.setAttribute('tabindex', '0');
            question.setAttribute('aria-expanded', 'false');
        });
    }
    
    // ===============================
    // ANIMACIONES EN SCROLL
    // ===============================
    function initAnimationsOnScroll() {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                    entry.target.classList.add('animated');
                    
                    // Animaciones especiales
                    if (entry.target.classList.contains('benefit-item')) {
                        animateCounter(entry.target);
                    }
                    
                    if (entry.target.classList.contains('testimonial-item')) {
                        animateTestimonial(entry.target);
                    }
                }
            });
        }, observerOptions);
        
        // Observar elementos animables
       /* const animatedElements = document.querySelectorAll(`
            .benefit-item,
            .problem-item,
            .urgency-item,
            .testimonial-item,
            .benefit-card,
            .solution-intro
        `);
        
        animatedElements.forEach((el, index) => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(30px)';
            el.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`;
            observer.observe(el);
        });*/
    }
    
    function animateCounter(element) {
        const emoji = element.querySelector('.benefit-emoji');
        if (emoji) {
            emoji.style.animation = 'pulse 0.8s ease-in-out';
            setTimeout(() => {
                emoji.style.animation = '';
            }, 800);
        }
    }
    
    function animateTestimonial(element) {
        const text = element.querySelector('.testimonial-text p');
        if (text) {
            text.style.animation = 'fadeInUp 0.8s ease-out 0.3s both';
        }
    }
    
    // ===============================
    // EFECTOS DE SCROLL ADICIONALES
    // ===============================
    function initScrollEffects() {
        let ticking = false;
        
        function handleScroll() {
            const scrolled = window.pageYOffset;
            const parallaxElements = document.querySelectorAll('[data-parallax]');
            
            parallaxElements.forEach(element => {
                const speed = element.dataset.parallax || 0.5;
                const yPos = -(scrolled * speed);
                element.style.transform = `translate3d(0, ${yPos}px, 0)`;
            });
            
            ticking = false;
        }
        
        window.addEventListener('scroll', function() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        });
    }
    
    // ===============================
    // SISTEMA DE NOTIFICACIONES
    // ===============================
    function showNotification(message, type = 'info', duration = 5000) {
        const notification = document.createElement('div');
        notification.className = `notification notification-${type}`;
        notification.innerHTML = `
            <div class="notification-content">
                <span class="notification-message">${message}</span>
                <button class="notification-close" onclick="this.parentElement.parentElement.remove()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        `;
        
        document.body.appendChild(notification);
        
        // Auto-remove
        setTimeout(() => {
            if (notification.parentElement) {
                notification.style.animation = 'slideInRight 0.3s ease-out reverse';
                setTimeout(() => notification.remove(), 300);
            }
        }, duration);
        
        return notification;
    }
    
    function showNotificationP(message, type = 'info', duration = 5000) {
        const notificationp = document.createElement('div');
        notificationp.className = `notificationp notificationp-${type}`;
        notificationp.innerHTML = `
            <div class="notification-content">
                <span class="notification-message">${message}</span>
                <button class="notification-close" onclick="this.parentElement.parentElement.remove()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        `;
        
        document.body.appendChild(notificationp);
        
        // Auto-remove
        setTimeout(() => {
            if (notificationp.parentElement) {
                notificationp.style.animation = 'slideInRight 0.3s ease-out reverse';
                setTimeout(() => notificationp.remove(), 300);
            }
        }, duration);
        
        return notificationp;
    }
    
    
    
    // ===============================
    // ANALYTICS Y TRACKING
    // ===============================
    function initAnalytics() {
        // Track page view
        trackEvent('Page', 'View', 'TRANSFÓRMATE Landing');
        
        // Track scroll depth
        let maxScroll = 0;
        window.addEventListener('scroll', throttle(function() {
            const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
            
            if (scrollPercent > maxScroll) {
                maxScroll = scrollPercent;
                
                // Track milestones
                if ([25, 50, 75, 100].includes(scrollPercent)) {
                    trackEvent('Engagement', 'Scroll', `${scrollPercent}%`);
                }
            }
        }, 1000));
        
        // Track time on page
        let startTime = Date.now();
        window.addEventListener('beforeunload', function() {
            const timeSpent = Math.round((Date.now() - startTime) / 1000);
            trackEvent('Engagement', 'Time on Page', timeSpent.toString());
        });
        
        // Track visibility changes
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                trackEvent('Engagement', 'Page Hidden', '');
            } else {
                trackEvent('Engagement', 'Page Visible', '');
            }
        });
    }
    
    function trackEvent(category, action, label, value) {
        // Google Analytics 4
        if (typeof gtag !== 'undefined') {
            gtag('event', action, {
                event_category: category,
                event_label: label,
                value: value
            });
        }
        
        // Facebook Pixel
        if (typeof fbq !== 'undefined') {
            fbq('track', 'CustomEvent', {
                category: category,
                action: action,
                label: label
            });
        }
        
        // Console log para debug
        //console.log(`📊 Event tracked: ${category} - ${action} - ${label}`);
    }
    
    // ===============================
    // UTILIDADES
    // ===============================
    function throttle(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }
    
    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    
    // ===============================
    // FUNCIONES ESPECIALES PARA EL EVENTO
    // ===============================
    function initUrgencyEffects() {
        const urgencyTexts = document.querySelectorAll('.urgency-text, .final-urgency p');
        
        urgencyTexts.forEach(text => {
            setInterval(() => {
                text.style.animation = 'none';
                setTimeout(() => {
                    text.style.animation = 'blink 2s infinite';
                }, 10);
            }, 10000); // Reiniciar cada 10 segundos
        });
    }
    
    function initTestimonialRotation() {
        const testimonials = document.querySelectorAll('.testimonial-item');
        if (testimonials.length <= 3) return;
        
        let currentIndex = 0;
        
        function showTestimonials() {
            testimonials.forEach((testimonial, index) => {
                if (index >= currentIndex && index < currentIndex + 3) {
                    testimonial.style.display = 'block';
                    testimonial.style.animation = 'fadeInUp 0.6s ease-out';
                } else {
                    testimonial.style.display = 'none';
                }
            });
            
            currentIndex = (currentIndex + 3) % testimonials.length;
        }
        
        // Rotar testimonios cada 8 segundos
        setInterval(showTestimonials, 8000);
    }
    
    // Inicializar efectos especiales
    initUrgencyEffects();
    initTestimonialRotation();
    
    
    // ===============================
    // OPTIMIZACIONES DE RENDIMIENTO
    // ===============================
    function initPerformanceOptimizations() {
        // Lazy loading de imágenes
        const images = document.querySelectorAll('img[data-src]');
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });
        
        images.forEach(img => {
            img.classList.add('lazy');
            imageObserver.observe(img);
        });
        
        // Preload de recursos críticos
        const criticalResources = [
            'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css',
            'https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800;900&display=swap'
        ];
        
        criticalResources.forEach(resource => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.href = resource;
            link.as = resource.endsWith('.css') ? 'style' : 'script';
            document.head.appendChild(link);
        });
    }
    
    initPerformanceOptimizations();
    
    // ===============================
    // ERROR HANDLING
    // ===============================
    window.addEventListener('error', function(e) {
        console.error('Error en Marina TRANSFÓRMATE Landing:', e.error);
        
        // Track error
        trackEvent('Error', 'JavaScript', e.message || 'Unknown error');
        
        // Opcional: enviar errores a un servicio de monitoreo
        // sendErrorToService(e.error);
    });
    
    // ===============================
    // FUNCIONES ESPECÍFICAS DEL EVENTO
    // ===============================
    
    // Contador de plazas disponibles (simulado)
    function initPlazasCounter() {
        const plazasElements = document.querySelectorAll('[data-plazas]');
        let plazasDisponibles = 47; // Número simulado
        
        plazasElements.forEach(element => {
            element.textContent = plazasDisponibles;
        });
        
        // Simular disminución de plazas cada cierto tiempo
        setInterval(() => {
            if (plazasDisponibles > 15 && Math.random() > 0.7) {
                plazasDisponibles--;
                plazasElements.forEach(element => {
                    element.textContent = plazasDisponibles;
                    element.style.animation = 'pulse 0.5s ease-in-out';
                    setTimeout(() => {
                        element.style.animation = '';
                    }, 500);
                });
                
                // Mostrar notificación cuando quedan pocas plazas
                if (plazasDisponibles === 20) {
                    showNotification('⚠️ Solo quedan 20 plazas disponibles', 'warning', 8000);
                } else if (plazasDisponibles === 10) {
                    showNotification('🚨 ¡Solo quedan 10 plazas! Asegurá tu lugar', 'error', 10000);
                }
            }
        }, 45000); // Cada 45 segundos
    }
    
    // Testimonios dinámicos con efecto typewriter
    function initTypewriterEffect() {
        const testimonialTexts = document.querySelectorAll('.testimonial-text p');
        
        testimonialTexts.forEach((text, index) => {
            const originalText = text.textContent;
            text.textContent = '';
            
            setTimeout(() => {
                typeWriter(text, originalText, 30);
            }, index * 2000);
        });
    }
    
    function typeWriter(element, text, speed) {
        let i = 0;
        function type() {
            if (i < text.length) {
                element.textContent += text.charAt(i);
                i++;
                setTimeout(type, speed);
            }
        }
        type();
    }
    
    // Animación de números para estadísticas
    function animateNumbers() {
        const numberElements = document.querySelectorAll('[data-animate-number]');
        
        numberElements.forEach(element => {
            const finalNumber = parseInt(element.dataset.animateNumber);
            const duration = 2000;
            const steps = 60;
            const increment = finalNumber / steps;
            let current = 0;
            
            const timer = setInterval(() => {
                current += increment;
                if (current >= finalNumber) {
                    current = finalNumber;
                    clearInterval(timer);
                }
                element.textContent = Math.floor(current);
            }, duration / steps);
        });
    }
    
    // Efecto de revelado de beneficios
    function initBenefitsReveal() {
        const benefits = document.querySelectorAll('.benefit-item');
        
        benefits.forEach((benefit, index) => {
            benefit.addEventListener('mouseenter', function() {
                this.style.transform = 'translateY(-15px) scale(1.05)';
                this.style.zIndex = '10';
                
                // Efecto de "glow"
                this.style.boxShadow = '0 25px 50px rgba(111, 132, 122, 0.3)';
            });
            
            benefit.addEventListener('mouseleave', function() {
                this.style.transform = 'translateY(0) scale(1)';
                this.style.zIndex = '1';
                this.style.boxShadow = '';
            });
        });
    }
    
    // Sistema de seguimiento de interacciones
    function initInteractionTracking() {
        // Track clicks en secciones específicas
        const sections = document.querySelectorAll('section[class*="section"]');
        
        sections.forEach(section => {
            section.addEventListener('click', function(e) {
                const sectionName = this.className.split('-')[0];
                trackEvent('Section Interaction', 'Click', sectionName);
            });
        });
        
        // Track tiempo en cada sección
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const sectionName = entry.target.className.split('-')[0];
                    entry.target.dataset.startTime = Date.now();
                    trackEvent('Section', 'Enter', sectionName);
                } else {
                    const sectionName = entry.target.className.split('-')[0];
                    const startTime = entry.target.dataset.startTime;
                    if (startTime) {
                        const timeSpent = Math.round((Date.now() - startTime) / 1000);
                        trackEvent('Section', 'Time Spent', sectionName, timeSpent);
                    }
                }
            });
        }, { threshold: 0.5 });
        
        sections.forEach(section => {
            sectionObserver.observe(section);
        });
    }
    
    // Popup de salida (exit-intent)
 /*   function initExitIntent() {
        let hasShownPopup = true;
        
        document.addEventListener('mouseleave', function(e) {
            if (!hasShownPopup && e.clientY <= 0) {
                hasShownPopup = true;
                //showExitIntentPopup();
                trackEvent('Exit Intent', 'Trigger', 'Mouse Leave');
            }
        });
        
        // También activar con scroll hacia arriba rápido
        let lastScrollY = window.scrollY;
        window.addEventListener('scroll', function() {
            const currentScrollY = window.scrollY;
            
            if (!hasShownPopup && currentScrollY < lastScrollY && currentScrollY < 500) {
                if (Math.abs(lastScrollY - currentScrollY) > 150) {
                    hasShownPopup = true;
                    setTimeout(() => {
                        //showExitIntentPopup();
                        trackEvent('Exit Intent', 'Trigger', 'Fast Scroll Up');
                    }, 500);
                }
            }
            
            lastScrollY = currentScrollY;
        });
    }
    
function showExitIntentPopup() {
    const popup = document.createElement('div');
    popup.className = 'exit-intent-popup';
    popup.innerHTML = `
        <div class="popup-overlay">
            <div class="popup-content">
                <button class="popup-close">&times;</button>
                <h3>¡Esperá! 🚨</h3>
                <p><strong>¿Te vas sin asegurar tu lugar?</strong></p>
                <p>Las plazas para TRANSFÓRMATE se están agotando rápidamente. Esta es tu oportunidad de cambiar tu relación con la menopausia para siempre.</p>
                <div class="popup-offer">
                    <p>🎁 <strong>Solo por hoy:</strong> 15% de descuento extra</p>
                    <code>CODIGO: NOMEVAYAS15</code>
                </div>
                <a href="#entradas" class="btn btn-primary popup-cta">QUIERO MI LUGAR</a>
                <p class="popup-small">* Oferta válida solo para los próximos 15 minutos</p>
            </div>
        </div>
    `;
    
    // Crear estilos CSS si no existen
    if (!document.querySelector('#exit-intent-styles')) {
        const styles = document.createElement('style');
        styles.id = 'exit-intent-styles';
        styles.textContent = `
            .exit-intent-popup {
                position: fixed !important;
                top: 0 !important;
                left: 0 !important;
                width: 100% !important;
                height: 100% !important;
                background: rgba(0, 0, 0, 0.85) !important;
                z-index: 10000 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                animation: fadeIn 0.4s ease-out !important;
                backdrop-filter: blur(5px) !important;
            }
            
            .popup-overlay {
                width: 100% !important;
                height: 100% !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 20px !important;
            }
            
            .popup-content {
                background: #ffffff !important;
                border-radius: 20px !important;
                padding: 40px 30px !important;
                max-width: 500px !important;
                width: 100% !important;
                text-align: center !important;
                position: relative !important;
                box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3) !important;
                animation: slideInUp 0.4s ease-out !important;
                border: 3px solid #C96F7A !important;
            }
            
            .popup-close {
                position: absolute !important;
                top: 15px !important;
                right: 20px !important;
                background: none !important;
                border: none !important;
                font-size: 28px !important;
                color: #777777 !important;
                cursor: pointer !important;
                transition: color 0.3s ease !important;
                line-height: 1 !important;
                width: 30px !important;
                height: 30px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
            }
            
            .popup-close:hover {
                color: #C96F7A !important;
                transform: scale(1.1) !important;
            }
            
            .popup-content h3 {
                color: #C96F7A !important;
                font-size: 28px !important;
                font-weight: 700 !important;
                margin: 0 0 20px 0 !important;
                font-family: 'DM Sans', sans-serif !important;
            }
            
            .popup-content p {
                color: #777777 !important;
                font-size: 16px !important;
                line-height: 1.6 !important;
                margin: 0 0 15px 0 !important;
                font-family: 'DM Sans', sans-serif !important;
            }
            
            .popup-offer {
                background: linear-gradient(135deg, #6F847A, #C96F7A) !important;
                color: white !important;
                padding: 20px !important;
                border-radius: 15px !important;
                margin: 25px 0 !important;
            }
            
            .popup-offer p {
                color: white !important;
                margin: 0 0 10px 0 !important;
                font-size: 18px !important;
                font-weight: 600 !important;
            }
            
            .popup-offer code {
                background: rgba(255, 255, 255, 0.2) !important;
                color: white !important;
                padding: 8px 15px !important;
                border-radius: 8px !important;
                font-size: 16px !important;
                font-weight: bold !important;
                letter-spacing: 1px !important;
                display: inline-block !important;
                font-family: 'DM Sans', monospace !important;
            }
            
            .popup-cta {
                background: linear-gradient(135deg, #6F847A, #C96F7A) !important;
                color: white !important;
                padding: 18px 35px !important;
                border-radius: 12px !important;
                text-decoration: none !important;
                font-weight: 700 !important;
                font-size: 16px !important;
                text-transform: uppercase !important;
                letter-spacing: 0.5px !important;
                display: inline-block !important;
                margin: 20px 0 !important;
                transition: all 0.3s ease !important;
                border: none !important;
                font-family: 'DM Sans', sans-serif !important;
                box-shadow: 0 4px 15px rgba(111, 132, 122, 0.3) !important;
            }
            
            .popup-cta:hover {
                background: linear-gradient(135deg, #C96F7A, #6F847A) !important;
                transform: translateY(-2px) !important;
                box-shadow: 0 6px 20px rgba(111, 132, 122, 0.4) !important;
            }
            
            .popup-small {
                font-size: 12px !important;
                color: #999999 !important;
                font-style: italic !important;
                margin: 15px 0 0 0 !important;
            }
            
            @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            
            @keyframes slideInUp {
                from {
                    opacity: 0;
                    transform: translateY(30px) scale(0.95);
                }
                to {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                }
            }
            
            @media (max-width: 600px) {
                .popup-content {
                    padding: 30px 20px !important;
                    margin: 10px !important;
                }
                
                .popup-content h3 {
                    font-size: 24px !important;
                }
                
                .popup-content p {
                    font-size: 14px !important;
                }
                
                .popup-offer {
                    padding: 15px !important;
                }
                
                .popup-offer p {
                    font-size: 16px !important;
                }
                
                .popup-cta {
                    padding: 16px 30px !important;
                    font-size: 14px !important;
                }
            }
        `;
        document.head.appendChild(styles);
    }
    
    // Añadir al DOM
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    
    // Debug para verificar que se añadió
    //console.log('🚨 Exit intent popup mostrado');
    
    // Función para cerrar popup
    function closePopup() {
        if (document.body.contains(popup)) {
            popup.style.animation = 'fadeIn 0.3s ease-out reverse';
            setTimeout(() => {
                if (document.body.contains(popup)) {
                    document.body.removeChild(popup);
                }
                document.body.style.overflow = '';
            }, 300);
        }
    }
    
    // Cerrar popup con botón X
    const closeBtn = popup.querySelector('.popup-close');
    closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closePopup();
        trackEvent('Exit Intent', 'Close Button', 'Manual');
    });
    
    // Cerrar al hacer click en el overlay (fuera del contenido)
    popup.addEventListener('click', function(e) {
        if (e.target === popup || e.target.classList.contains('popup-overlay')) {
            closePopup();
            trackEvent('Exit Intent', 'Close Overlay', 'Manual');
        }
    });
    
    // Manejar click en CTA
    const ctaBtn = popup.querySelector('.popup-cta');
    ctaBtn.addEventListener('click', function(e) {
        closePopup();
        trackEvent('Exit Intent', 'CTA Click', 'Conversion');
        // El link llevará automáticamente a #entradas
    });
    
    // Cerrar con tecla Escape
    function handleEscape(e) {
        if (e.key === 'Escape') {
            closePopup();
            trackEvent('Exit Intent', 'Close Escape', 'Manual');
            document.removeEventListener('keydown', handleEscape);
        }
    }
    document.addEventListener('keydown', handleEscape);
    
    // Auto-cerrar después de 45 segundos
    setTimeout(() => {
        closePopup();
        trackEvent('Exit Intent', 'Auto Close', 'Timeout');
        document.removeEventListener('keydown', handleEscape);
    }, 45000);
    
    // Track que se mostró
    trackEvent('Exit Intent', 'Show', 'Popup Displayed');
}*/
    
    // Sistema de recomendaciones sociales
function initSocialProof() {
    const nombres = [
        "Eva", "Carmen", "Rosario", "Patricia", "María", "Emilia",
        "Carolina", "Carla", "Silvia", "Mónica", "Pepa","Caricia"
    ];
    
    const localidades = [
        // Cerca de Buenos Aires y cercanías (5)
        "Málaga", "Marbella", "Estepona", "Ronda", "Coín", "Antequera",
        // Más alejadas (2)
        "Cordoba", "Sevilla", "Madrid"
    ];
    
    const acciones = [
        "acaba de comprar su entrada",
        "se unió al evento",
        "aseguró su lugar",
        "no quiso perderse esta oportunidad",
        "decidió transformar su menopausia",
        "ya eligió su entrada",
        "confía en Marina para su transformación",
        "acaba de reservar su lugar",
        "se suma a la experiencia TRANSFÓRMATE",
        "decidió invertir en su bienestar"
    ];
    
    function generateRandomMessage() {
        const nombre = nombres[Math.floor(Math.random() * nombres.length)];
        const localidad = localidades[Math.floor(Math.random() * localidades.length)];
        const accion = acciones[Math.floor(Math.random() * acciones.length)];
        
        return `${nombre} de ${localidad} ${accion}`;
    }
    
    function showSocialProof() {
        const message = generateRandomMessage();
        const notification = showNotificationP(`👥 ${message}`, 'info', 4000);
        
        notification.style.background = '#C96F7A';
        notification.style.color = 'white';
        
        // Pequeña animación extra
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
            notification.style.transform = 'translateX(0)';
            notification.style.transition = 'transform 0.4s ease-out';
        }, 100);
    }
    
    // Mostrar primera notificación después de 8 segundos
    setTimeout(showSocialProof, 8000);
    
    // Luego cada 35-75 segundos con variación aleatoria
    setInterval(() => {
        if (Math.random() > 0.25) { // 75% de probabilidad
            showSocialProof();
        }
    }, 15000 + Math.random() * 40000); // Entre 35-75 segundos
}
    
    // Inicializar funciones específicas del evento
    initPlazasCounter();
    // initTypewriterEffect(); // Opcional, puede ser pesado
    initBenefitsReveal();
    initInteractionTracking();
    
    // Inicializar después de 5 segundos para no interferir con la carga
    setTimeout(() => {
        //initExitIntent();
        initSocialProof();
    }, 5000);
    
    // ===============================
    // COMPATIBILIDAD Y FALLBACKS
    // ===============================
    
    // Detectar soporte de características
    function checkFeatureSupport() {
        const features = {
            intersectionObserver: 'IntersectionObserver' in window,
            requestAnimationFrame: 'requestAnimationFrame' in window,
            fetch: 'fetch' in window,
            es6: (() => {
                try {
                    new Function("(a = 0) => a");
                    return true;
                } catch (err) {
                    return false;
                }
            })()
        };
        
        //console.log('📋 Feature support:', features);
        
        // Fallbacks para navegadores antiguos
        if (!features.intersectionObserver) {
            // Fallback simple para animaciones
            const elements = document.querySelectorAll('[data-animate]');
            elements.forEach(el => {
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
            });
        }
        
        if (!features.fetch) {
            console.warn('⚠️ Fetch not supported, cart functions may not work');
        }
        
        return features;
    }
    
    checkFeatureSupport();
    
    // ===============================
    // FINALIZACIÓN
    // ===============================
    
    // Dispatch evento personalizado cuando todo esté listo
    window.dispatchEvent(new CustomEvent('marinaTransformateReady', {
        detail: {
            timestamp: Date.now(),
            features: checkFeatureSupport()
        }
    }));
    
    //console.log('✨ Marina TRANSFÓRMATE está lista para transformar vidas! 🦋');
    
    // ===============================
// DIRECT BUY FUNCTIONALITY
// ===============================
function initDirectBuy() {
    const directBuyForms = document.querySelectorAll('.direct-buy-form');
    
    directBuyForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const variantId = this.dataset.variantId;
            const btnText = this.querySelector('.btn-text');
            const btnLoading = this.querySelector('.btn-loading');
            const button = this.querySelector('.btn-purchase');
            
            // Mostrar loading
            btnText.classList.add('hidden');
            btnLoading.classList.remove('hidden');
            button.disabled = true;
            
            // Datos para añadir al carrito
            const formData = new FormData(form);
            
            // Añadir al carrito via AJAX
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.status && data.status === 422) {
                    throw new Error(data.description || 'Error al añadir al carrito');
                }
                
                // Éxito - mostrar notificación
                showNotification('¡Entrada añadida exitosamente! Redirigiendo al carrito...', 'success');
                
                // Actualizar contador del carrito
                updateCartCount();
                
                // Track conversion
                trackEvent('Purchase', 'Add to Cart', `Entrada ${getVariantName(variantId)}`);
                
                // Redirigir al carrito después de 1.5 segundos
                setTimeout(() => {
                    window.location.href = '/cart';
                }, 1500);
                
            })
            .catch(error => {
                console.error('Error:', error);
                showNotification('Error al procesar la compra. Por favor inténtalo de nuevo.', 'error');
                
                // Track error
                trackEvent('Purchase', 'Error', error.message);
            })
            .finally(() => {
                // Restaurar botón después de 2 segundos
                setTimeout(() => {
                    btnText.classList.remove('hidden');
                    btnLoading.classList.add('hidden');
                    button.disabled = false;
                }, 2000);
            });
        });
    });
    
    function getVariantName(variantId) {
        const form = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (form) {
            const card = form.closest('.pricing-card');
            const title = card.querySelector('h3');
            return title ? title.textContent.trim() : 'Desconocida';
        }
        return 'Desconocida';
    }
}


// SOLO PARA TESTING - REMOVER EN PRODUCCIÓN
function initTestMode() {
    //console.log('🚧 TEST MODE - Product inactive');
    
    const directBuyForms = document.querySelectorAll('.direct-buy-form');
    
    directBuyForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const btnText = form.querySelector('.btn-text');
            const btnLoading = form.querySelector('.btn-loading');
            const button = form.querySelector('.btn-purchase');
            
            // Simular loading
            btnText.classList.add('hidden');
            btnLoading.classList.remove('hidden');
            button.disabled = true;
            
            // Simular éxito después de 2 segundos
            setTimeout(() => {
                showNotification('🚧 TEST MODE: Compra simulada exitosa', 'success');
                //console.log('🚧 En producción iría a /checkout');
                
                // Restaurar botón
                btnText.classList.remove('hidden');
                btnLoading.classList.add('hidden');
                button.disabled = false;
            }, 2000);
        });
    });
}

    
    
}); // Fin del DOMContentLoaded

// ===============================
// FUNCIONES GLOBALES
// ===============================

// Función para scroll suave desde cualquier lugar
window.scrollToSection = function(sectionId) {
    const element = document.querySelector(sectionId);
    if (element) {
        const headerHeight = document.querySelector('.marina-header').offsetHeight;
        const targetPosition = element.offsetTop - headerHeight - 20;
        
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
};

// Función para mostrar modal de contacto (si se implementa)
window.showContactModal = function() {
    //console.log('📞 Contact modal requested');
    // Implementar modal de contacto si es necesario
};

// Función para compartir en redes sociales
window.shareEvent = function(platform) {
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent('TRANSFÓRMATE - Marina Borensztein');
    const text = encodeURIComponent('¡No te pierdas este evento único para transformar tu menopausia!');
    
    const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
        whatsapp: `https://wa.me/?text=${text}%20${url}`,
        telegram: `https://t.me/share/url?url=${url}&text=${text}`
    };
    
    if (shareUrls[platform]) {
        window.open(shareUrls[platform], '_blank', 'width=600,height=400');
        
        // Track social share
        if (typeof trackEvent === 'function') {
            trackEvent('Social Share', platform, 'TRANSFÓRMATE Event');
        }
    }
};



